var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError5001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 238,
    viewBox: "0 0 362 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.947 82.0004L162.351 80.1748L184.506 38.346L185.688 36.1138L183.178 36.3998L167.787 38.1538L181.682 3.97821L243.513 20.5458C249.738 22.2137 253.432 28.6119 251.764 34.8367L227.176 126.6C225.508 132.824 219.11 136.518 212.885 134.85L157.347 119.969L176.939 83.9564L177.864 82.2577L175.947 82.0004Z",
    fill: "white",
    stroke: "#28293D",
    strokeWidth: 2.66303
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.745 62.9707L196.846 67.1955L201.948 71.4203",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.071 62.0938L196.846 67.1956L192.622 72.2974",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.748 23.25L249.09 43.4379",
    stroke: "#28293D",
    strokeWidth: 2.66303
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.423 86.9335L148.203 88.7484L149.998 88.401L163.604 85.7675L157.656 120.166L93.1465 126.232C86.7304 126.836 81.0401 122.124 80.4368 115.708L71.5427 21.1249C70.9394 14.7089 75.6515 9.01855 82.0676 8.41522L140.597 2.91142L138.914 43.5386L138.83 45.5691L140.725 44.8355L154.156 39.6366L148.423 86.9335Z",
    fill: "white",
    stroke: "#28293D",
    strokeWidth: 2.66303
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3664 30.0872L141.063 23.6273",
    stroke: "#28293D",
    strokeWidth: 2.66303
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.351 71.3389L105.453 75.5637L110.555 79.7885",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.678 70.4619L105.453 75.5638L101.228 80.6656",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5857,
    cy: 18.7834,
    r: 3.99454,
    transform: "rotate(-5.372 85.5857 18.7834)",
    fill: "#28293D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.8424,
    cy: 17.5369,
    r: 3.99454,
    transform: "rotate(-5.372 98.8424 17.5369)",
    fill: "#28293D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.099,
    cy: 16.2903,
    r: 3.99454,
    transform: "rotate(-5.372 112.099 16.2903)",
    fill: "#28293D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.766 92.5332L142.875 85.0059",
    stroke: "#28293D",
    strokeWidth: 3.1226,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.778 92.5303L113.614 100.118C114.425 103.47 117.8 105.53 121.152 104.719V104.719C124.505 103.908 126.565 100.533 125.754 97.1803L123.918 89.5928",
    stroke: "#28293D",
    strokeWidth: 3.1226
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M355 32L357.663 34.663M357.663 34.663L360.326 37.3261M357.663 34.663L360.326 32M357.663 34.663L355 37.3261",
    stroke: "#28293D",
    strokeWidth: 2.66303,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289 104L294.992 109.992M294.992 109.992L300.984 115.984M294.992 109.992L300.984 104M294.992 109.992L289 115.984",
    stroke: "#28293D",
    strokeWidth: 5.99181,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M313 45L315.663 47.663M315.663 47.663L318.326 50.3261M315.663 47.663L318.326 45M315.663 47.663L313 50.3261",
    stroke: "#28293D",
    strokeWidth: 2.66303,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M318 81L321.995 84.9945M321.995 84.9945L325.989 88.9891M321.995 84.9945L325.989 81M321.995 84.9945L318 88.9891",
    stroke: "#28293D",
    strokeWidth: 2.66303,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M278 73L281.995 76.9945M281.995 76.9945L285.989 80.9891M281.995 76.9945L285.989 73M281.995 76.9945L278 80.9891",
    stroke: "#28293D",
    strokeWidth: 2.66303,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4906 126.001L25.8143 130.13L27.6405 149.89C29.3557 147.614 31.8698 145.648 35.1829 143.994C38.4961 142.34 42.1573 141.328 46.1668 140.957C53.3264 140.296 59.3951 141.371 64.3727 144.185C69.4457 146.989 73.3183 150.868 75.9903 155.82C78.6624 160.772 80.2763 166.255 80.8321 172.269C81.8643 183.438 79.5345 192.607 73.8428 199.776C68.1422 206.85 59.5642 210.916 48.1087 211.975C40.4717 212.681 33.718 212.005 27.8475 209.948C21.9682 207.796 17.285 204.522 13.7979 200.127C10.3109 195.731 8.14181 190.492 7.2908 184.409L31.2041 182.199C32.0503 185.105 33.6639 187.459 36.0448 189.261C38.4169 190.968 41.5122 191.644 45.3307 191.291C49.8174 190.877 53.0262 189.136 54.9572 186.069C56.8882 183.002 57.6331 179.083 57.192 174.309C56.7597 169.632 55.2833 166.158 52.7628 163.888C50.2423 161.617 46.7865 160.685 42.3952 161.091C39.1495 161.391 36.5515 162.449 34.6014 164.266C32.6423 165.988 31.4478 168.168 31.0178 170.807L7.39089 172.991L1.63432 110.702L68.5056 104.522L70.4906 126.001Z",
    fill: "#28293D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.011 181.408C108.337 164.922 111.757 151.996 118.271 142.633C124.881 133.27 135.279 128.73 149.465 129.011C163.651 129.291 173.813 134.239 179.951 143.853C186.185 153.47 189.139 166.521 188.813 183.007C188.483 199.685 185.013 212.705 178.403 222.067C171.889 231.431 161.539 235.973 147.353 235.692C133.167 235.411 122.957 230.463 116.723 220.846C110.585 211.232 107.681 198.086 108.011 181.408ZM164.658 182.529C164.85 172.848 163.943 165.399 161.937 160.181C159.932 154.868 155.623 152.146 149.009 152.015C142.396 151.884 137.982 154.433 135.769 159.663C133.558 164.798 132.357 172.205 132.165 181.886C132.036 188.404 132.312 193.827 132.994 198.155C133.677 202.388 135.142 205.869 137.39 208.598C139.735 211.234 143.208 212.597 147.808 212.688C152.409 212.779 155.886 211.553 158.237 209.011C160.687 206.375 162.336 202.955 163.187 198.753C164.039 194.455 164.529 189.047 164.658 182.529Z",
    fill: "#28293D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.106 173.736C222.296 157.392 227.157 144.938 234.689 136.371C242.316 127.817 253.161 124.483 267.224 126.367C281.287 128.252 290.824 134.318 295.834 144.566C300.94 154.826 302.398 168.127 300.207 184.471C297.991 201.004 293.07 213.548 285.443 222.102C277.911 230.668 267.114 234.009 253.051 232.124C238.988 230.24 229.404 224.167 224.298 213.907C219.287 203.66 217.89 190.269 220.106 173.736ZM276.262 181.262C277.548 171.665 277.49 164.161 276.087 158.75C274.697 153.243 270.724 150.051 264.168 149.172C257.611 148.294 252.938 150.327 250.147 155.273C247.369 160.124 245.337 167.348 244.051 176.945C243.185 183.406 242.845 188.826 243.033 193.203C243.232 197.486 244.294 201.111 246.218 204.077C248.25 206.961 251.546 208.708 256.107 209.32C260.668 209.931 264.261 209.106 266.885 206.847C269.617 204.504 271.643 201.294 272.964 197.215C274.297 193.041 275.396 187.723 276.262 181.262Z",
    fill: "#28293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError5001);
export default __webpack_public_path__ + "static/media/error_500_1.682d485038dc4bcdb02f3c99c65617db.svg";
export { ForwardRef as ReactComponent };